// extracted by mini-css-extract-plugin
module.exports = {"button":"SkjemadetaljerButton_button__wAoLT"};